<template>
    <div v-if="show" class="user-panel">
        <template v-if="!enableBellLicense">
            <div style="text-align:center;padding-top:40px">
                {{$t('message.error_need_bell_option')}}
            </div>
        </template>

        <template v-else>
            <table v-if="isExpireTrialContract()" width=100% class="alertfield">
                <tr v-if="isBillingPaper()" class="alertrecord" v-t="{ path: 'message.info_trial_expire_notice_for_customer', args: { expireDate: getExpireDateTime() } }"></tr>
                <tr v-else class="alertrecord" v-t="{ path: 'message.info_trial_expire_notice_for_web', args: { expireDate: getExpireDateTime() } }"></tr>
            </table>
            <table v-else-if="isExpirePurchasedContract()" width=100% class="alertfield">
                <tr v-if="isBillingPaper()" class="alertrecord" v-t="{ path: 'message.info_contract_expire_notice_for_customer', args: { expireDate: getExpireDateTime() } }"></tr>
                <tr v-else class="alertrecord" v-t="{ path: 'message.info_contract_expire_notice_for_web', args: { expireDate: getExpireDateTime() } }"></tr>
            </table>
            <table v-else-if="!appData.tenantAdminUser" width=100% class="alertfield">
                <tr class="alertrecord" v-t="'message.info_cannot_manage_bell'">
                </tr>
            </table>
            <table height=100% width=100% cellpadding=0 cellspacing=0>
                <tr height="56px">
                    <td colspan=2>
                        <div class="command-area">
                            <!-- Add -->
                            <div class="command-area-left">
                                <span v-if="!appData.tenantAdminUser">
                                    <el-button class="disable-command-button" style="width:140px" v-t="'message.action_create_bell'"/>
                                </span>
                                <span v-else-if="disableCreateBell">
                                    <el-tooltip effect="light" placement="top-start" >
                                        <div slot="content" style="text-align:left" v-t="'message.error_import_processing'"/>
                                        <el-button class="disable-command-button" style="width:140px" v-t="'message.action_create_bell'"/>
                                    </el-tooltip>
                                </span>
                                <span v-else>
                                    <el-button class="enable-command-button" style="width:140px" v-on:click="showCreateBell=true" v-t="'message.action_create_bell'"/>
                                </span>
                            </div>
                            <!-- CSV Import -->
                            <div class="command-area-right">
                                <el-popover placement="left" width="230" trigger="manual" v-model="showCsvProcessing">
                                    <div class="csv-progress-title">
                                        {{ csvProcessStatusDescription }}
                                    </div>
                                    <div v-if="showImportCsvProcess">
                                        <div v-if="csvErrorCount > 0" class="csv-progress-title" style="padding-top:0px" v-t="{ path: 'message.item_error_count', args: { csvErrorCount: csvErrorCount } }">
                                        </div>
                                        <el-progress :text-inside="true" :stroke-width="18" color="#5171cb" :percentage="csvProgress"></el-progress>
                                        <div v-if="(!csvProcessedAll) && (!csvAborted)" style="padding:20px 0 0 0;text-align:center">
                                            <el-button class="dialog-small-button" @click="handleCancelImport()" :disabled="canceling" v-t="'message.action_cancel_process'"></el-button>
                                        </div>
                                        <div v-else-if="(csvErrorCount === 0) && csvAborted" style="padding:20px 0 0 0;text-align:center">
                                            <el-button class="dialog-small-button" @click="handleCloseCSVProgress()" v-t="'message.button_ok'"></el-button>
                                        </div>
                                        <div v-else style="padding:20px 0 0 0;text-align:center">
                                            <el-button class="dialog-small-button" @click="handleCloseCSVProgress()" v-t="'message.action_confirm_error'"></el-button>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div v-if="showExportCsvProcess" style="padding:10px 0;text-align:center" v-t="{ path: 'message.item_csv_execution_time', args: { execTime: csvExportExecTime } }"></div>
                                    </div>
                                    <button slot="reference" class="transparent" type="button" :disabled="!appData.tenantAdminUser" @click="handleShowCsvDialog()">
                                        <img src="../assets/icon_csv.svg"/><span class="normal-command" v-t="'message.action_csv_import'"></span>
                                    </button>
                                </el-popover>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr class="itemheader" style="border:none">
                    <td width="50%" height="100%">
                        <div class="inner-panel">
                            <div class="bellList">
                                <BellList
                                    v-bind:appData="appData"
                                    @on-selectnode="handleOnSelectNode"
                                    @resetSelectedNode="resetSelectedNode"
                                    ref="bellList">
                                </BellList>
                            </div>
                        </div>
                    </td>
                    <td width="50%">
                        <div class="inner-panel">
                            <div class="scrollable">
                                <component
                                    v-bind:selectedNode="selectedNode"
                                    v-bind:appData="appData"
                                    v-bind:bellDashboardUrl="bellDashboardUrl"
                                    v-bind:bellClientUrl="bellClientUrl"
                                    :is="selectedChild"
                                    ref="bellInfo"
                                    @resetSelectedNode="resetSelectedNode"
                                    @refresh="handleRefreshBellList">
                                </component>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
            <CreateBell v-if="showCreateBell" :appData="appData" :bellInfo="null" @create="createBell" @cancel="showCreateBell=false"></CreateBell>
            <ImportCSVBell v-if="showImportCsv" :showErrorInfo="showImportError" :csvResult="importErrorInfo" @import="importCsv" @export="exportCsv" @cancel="showImportCsv=false"></ImportCSVBell>
        </template>
    </div>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import BellList from "./BellList.vue"
import CreateBell from "./BellEdit.vue"
import ImportCSVBell from "./ImportCSVBell.vue";
import BellObject from "./BellObject.vue";
import VueVisible from 'vue-visible'
import InitialBellRightPanel from "./InitialBellRightPanel.vue"
import commonUtil from './commonutil.js';
import constants from './constants.js';

Vue.use(VueVisible)

export default {
    components: {
        BellList,
        BellObject,
        CreateBell,
        ImportCSVBell,
        InitialBellRightPanel,
    },

    props: {
        appData: Object
    },

    data () {
        return {
            showCreateBell: false,
            showImportCsv: false,
            showImportError: false,
            disableCreateBell: false,
            selectedNode: null,
            bellDashboardUrl: null,
            bellClientUrl: null,
            show: false,
            showCsvProcessing: false,
            showImportCsvProcess: false,
            showExportCsvProcess: false,
            csvType: "",
            csvProgress: 0,
            csvAborted: false,
            csvErrorCount: 0,
            csvExportExecTime: 0,
            csvProcessedAll: false,
            timerObj: null,
            importErrorInfo: null,
            csvProcessStatusDescription: null
        }
    },

    computed: {
        selectedChild() {
            if (this.selectedNode != null) {
                return "BellObject";
            }
            this.appData.selectedMenu = 'bell';
            return "InitialBellRightPanel";
        },

        enableBellLicense() {
            return this.appData.enableBell || this.appData.enableBellTrial;
        }
    },

    watch: {
        showImportCsvProcess(newVal) {
            if (newVal) {
                this.showCsvProcessing = true;
            } else {
                this.showCsvProcessing = false;
            }
        },
        showExportCsvProcess(newVal) {
            if (newVal) {
                this.showCsvProcessing = true;
            } else {
                this.showCsvProcessing = false;
            }
        },
        'appData.tenantList'(newVal) {
            if (newVal != null) {
                if (this.appData.basicContract != null) {
                    this.show = true;
                }
            }
        },
        'appData.basicContract'(newVal) {
            if (newVal != null) {
                if (this.appData.tenantList != null) {
                    this.show = true;
                }
            }
        },
        'appData.csvProcessing'(newVal) {
            if (this.appData.csvProcessing) {
                this.disableCreateCommand();
            } else {
                this.enableCreateCommand();
            }
        },
        '$route' (to, from) {
            if (to.name === "Bell") {
                this.resetSelectedNode();
                this.getCsvProcessState();
            }
            if (from.name === "Bell") {
                clearInterval(this.timerObj);
                this.timerObj = null;
                this.showImportCsvProcess = false;
            }
        }
    },

    mounted() {
        if (typeof this.$refs.bellList === "undefined") {
            // should reDraw to load bellList because bellList has destroyed when refreshing on the other menu item.
            this.show = false;
            this.$nextTick(() => {
                if ((this.appData.tenantList != null) && (this.appData.basicContract != null)) {
                    this.show = true
                }
            })
        }
    },

    created() {
        this.getBellClientUrl()
        this.getBellDashboardUrl();
        this.getCsvProcessState();
    },

    methods: {
        async getBellClientUrl() {
            try {
                const res = await server.post("/getbellclienturl")
                if (res.data.status === constants.STATUS_SUCCESS) {
                    this.bellClientUrl = res.data.url;
                }
            } catch (e) {
                console.log(e);
            }
        },
        async getBellDashboardUrl() {
            try {
                const res = await server.post("/getbelldashboardurl")
                if (res.data.status === constants.STATUS_SUCCESS) {
                    this.bellDashboardUrl = res.data.url;
                }
            } catch (e) {
                console.log(e);
            }
        },
        async createBell(payload) {
            try {
                const res = await server.post("/createbell", payload);
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "info_bell_add_success"));
                        this.showCreateBell = false;
                        this.handleRefreshBellList(true);
                        break;
                    case constants.STATUS_ERROR_ALREADY_EXISTED:
                        commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_bell_error_exists_same_name"));
                        break;
                    case constants.STATUS_ERROR_LICENSE_INSUFFICIENT:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_bell_exceed_max_count"));
                        break;
                    case constants.STATUS_ERROR_NO_MORE_FREE_SLOT:
                        commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_bell_no_more_free_slot"));
                        break;
                    case constants.STATUS_ERROR_CLOSING_RUNNING:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_cannot_create_bell_no_contract"));
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "createBell").replace("{code}", res.data.status));
                        break;
                }

            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "getInfo", e);
            }
        },
        exportCsv(exportType) {
            this.csvProcessStatusDescription = commonUtil.getMessageText(this.$i18n,"info_csv_exporting");
            this.showImportCsv = false;
            this.csvExportExecTime = 0;
            this.showExportCsvProcess = true;
            let downloadFileName;
            switch(exportType) {
                case constants.CSV_BELL:
                    downloadFileName = "buddycom_export_bell.csv";
                    break;
                case constants.CSV_BELL_AUTH_USER:
                    downloadFileName = "buddycom_export_auth_user.csv";
                    break;
            }
            this.timerObj = setInterval(() => self.getCsvProcessState(), 1000);
            let self = this;
            server.post("/exportcsv", {type: exportType, locale: this.$i18n.locale, offsetMinutes: this.getLocalOffsetMinutes()})
                .then(res => {
                    self.showExportCsvProcess = false;
                    self.appData.csvProcessing = false;
                    if( typeof res.data.status === 'undefined') {
                        const universalBOM = "\uFEFF";
                        const blob = new Blob([universalBOM + res.data], { type: 'application/csv;charset=UTF-8' })
                        commonUtil.downloadFile(blob, downloadFileName)
                    } else {
                        if (res.data.status === constants.STATUS_ERROR_EXCEEDS_MAX_COUNT) {
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_export_limit"));
                        } else if (res.data.status === constants.STATUS_ERROR_PERMISSION_DENIED) {
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_export_denied"));
                        } else {
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","exportCsv").replace("{code}",res.data.status));
                        }
                    }
                })
                .catch(err => {
                    self.showExportCsvProcess = false;
                    self.appData.csvProcessing = false;
                    commonUtil.putExceptionErrorMessage(self, "exportCsv", err);
                });
        },
        importCsv(importType , uploadFile) {
            this.showImportCsv = false;
            this.csvType = "";
            this.csvProgress = 0;
            this.csvErrorCount = 0;
            this.csvAborted = false;
            this.canceling = false;
            this.csvProcessedAll = false;
            let param = {
                importType: importType,
                csvFileName: uploadFile.name,
                offsetMinutes: this.getLocalOffsetMinutes()
            }
            let self = this;
            server.postWithFile("/importcsv", uploadFile, JSON.stringify(param))
                .then(res => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.timerObj = setInterval(() => self.getCsvProcessState(), 1000)
                            break;
                        case constants.STATUS_BUSY:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_import_processing"));
                            break;
                        case constants.STATUS_ERROR_EXCEEDS_MAX_SIZE:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_upload_file_too_big"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","importCsv").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch(err => {
                    commonUtil.putExceptionErrorMessage(self, "importCsv", err);
                });
        },
        getCsvProcessState() {
            clearInterval(this.timerObj);
            this.timerObj = null;
            let self = this;
            server.post("/getcsvprocstate")
                .then(res => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            if (res.data.importing && self.isBellMenuCsvProcessType(res.data.importType)) {
                                console.log(self.csvProgress);
                                self.csvType = res.data.importType;
                                self.csvProgress = res.data.progressPercentage;
                                self.csvErrorCount = res.data.errorCount;
                                self.csvProcessedAll = (res.data.processedCount == res.data.totalCount);
                                if (self.csvProcessedAll) {
                                    self.appData.csvProcessing = false;
                                    self.resetCsvImportProcess();
                                    switch(res.data.errorInfo.status) {
                                        case constants.STATUS_SUCCESS:
                                            self.showImportCsvProcess = false;
                                            commonUtil.notifyMessage(self, "Success",commonUtil.getMessageText(self.$i18n,"info_import_complete").replace("{resultCount}",res.data.totalCount));
                                            if (self.selectedNode != null) {
                                                if (res.data.importType === constants.CSV_BELL) {
                                                    self.$refs.bellInfo.getBellDetail();
                                                } else if (res.data.importType === constants.CSV_BELL_AUTH_USER) {
                                                    self.$refs.bellInfo.getBellAuthUsers();
                                                }
                                            }
                                            self.$refs.bellList.reload(true); // update bell list and reset select.
                                            break;
                                        case constants.STATUS_SUCCESS_WITH_ERRORINFO:
                                            self.showImportCsvProcess = false;
                                            commonUtil.notifyMessage(self, "Success",commonUtil.getMessageText(self.$i18n,"info_import_complete_with_error"));
                                            self.$refs.bellList.reload(true); // update bell list and reset select.
                                            break;
                                        default:
                                            self.csvProcessStatusDescription = self.getImportStatusDescription();
                                            self.importErrorInfo = res.data.errorInfo;
                                            if (!self.showImportCsvProcess) {
                                                self.showImportCsvProcess = true;
                                            }
                                    }
                                } else {
                                    let errorInfoStatus = res.data.errorInfo.status;
                                    let resetConditionDictionary = [];
                                    resetConditionDictionary[constants.STATUS_ERROR_EXCEEDS_MAX_COUNT] = commonUtil.getMessageText(self.$i18n, "error_csv_exceeds_limit");
                                    resetConditionDictionary[constants.STATUS_ERROR_TOO_MANY_ENTRY] = commonUtil.getMessageText(self.$i18n, "error_csv_exceeds_data");
                                    resetConditionDictionary[constants.STATUS_ERROR_INVALID_CSV_TEMPLATE] = commonUtil.getMessageText(self.$i18n, "error_csv_invalid_template");
                                    resetConditionDictionary[constants.STATUS_ERROR_INVALID_UTF8] = commonUtil.getMessageText(self.$i18n, "error_csv_invalid_utf8");
                                    resetConditionDictionary[constants.STATUS_ERROR_INVALID_CSV_FORMAT] = commonUtil.getMessageText(self.$i18n, "error_csv_invalid_format");
                                    resetConditionDictionary[constants.STATUS_ERROR_UNKNOWN] = commonUtil.getMessageText(self.$i18n, "error_csv_unknown").replace("{errorCode}",errorInfoStatus);
                                    resetConditionDictionary[constants.STATUS_ERROR_BELL_CSV_INVALID_TIMEZONE_HEADER] = commonUtil.getMessageText(self.$i18n, "error_csv_invalid_bell_timezone_header");

                                    if (errorInfoStatus in resetConditionDictionary) {
                                        self.resetCsvImportProcess();
                                        self.appData.csvProcessing = false;
                                        self.csvAborted = true;
                                        self.csvProcessStatusDescription = resetConditionDictionary[errorInfoStatus];
                                        self.importErrorInfo = res.data.errorInfo;
                                        if (!self.showImportCsvProcess) {
                                            self.showImportCsvProcess = true;
                                        }
                                        return;
                                    }

                                    self.appData.csvProcessing = true;
                                    if (!self.showImportCsvProcess) {
                                        self.showImportCsvProcess = true;
                                    }
                                    if (self.timerObj == null) {
                                        self.timerObj = setInterval(() => self.getCsvProcessState(), 1000);
                                    }
                                    self.csvProcessStatusDescription = this.getImportStatusDescription();
                                }
                            } else {
                                if (self.showImportCsvProcess) {
                                    self.appData.csvProcessing = false;
                                    self.canceling = false;
                                    if (res.data.errorInfo.status == constants.STATUS_ERROR_ABORT) {
                                        self.importErrorInfo = res.data.errorInfo;
                                        self.csvAborted = true;
                                    }
                                    self.csvProcessStatusDescription = this.getImportStatusDescription();
                                }
                            }
                            if (res.data.exporting && self.isBellMenuCsvProcessType(res.data.exportType)) {
                                self.csvExportExecTime = Math.floor((Date.now() - new Date(res.data.exportStartTime).getTime()) / 1000);
                                self.showExportCsvProcess = true;
                                self.appData.csvProcessing = true;
                                if (self.timerObj == null) {
                                    self.timerObj = setInterval(() => self.getCsvProcessState(), 1000);
                                }
                            } else {
                                if (self.showExportCsvProcess) {
                                    self.appData.csvProcessing = false;
                                    self.showExportCsvProcess = false;
                                }
                            }
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getCsvProcessState").replace("{code}",res.data.status));
                            self.csvProcessStatusDescription = this.getImportStatusDescription();
                            break;
                    }
                })
                .catch(err => {
                    commonUtil.putExceptionErrorMessage(self, "getCsvProcessState", err);
                    clearInterval(self.timerObj);
                    self.timerObj = null;
                });
        },
        isBellMenuCsvProcessType(type) {
            return type === constants.CSV_BELL || type === constants.CSV_BELL_AUTH_USER;
        },
        getImportStatusDescription() {
            if (this.csvAborted) {
                return commonUtil.getMessageText(this.$i18n,"info_csv_import_aborted");
            }
            if (this.csvProcessedAll) {
                return commonUtil.getMessageText(this.$i18n,"info_csv_import_completed");
            }
            if (this.canceling) {
                return commonUtil.getMessageText(this.$i18n,"info_csv_import_aborting");
            }
            return commonUtil.getMessageText(this.$i18n,"info_csv_importing");
        },
        resetCsvImportProcess() {
            let self = this;
            server.post("/changecsvimportprocess",{ type: "RESET", importType: self.csvType })
                .then(res => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                        case constants.STATUS_ERROR_NOT_FOUND:
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","resetCsvImportProcess").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch(err => {
                    commonUtil.putExceptionErrorMessage(self, "resetCsvImportProcess", err);
                });
        },
        resetSelectedNode() {
            this.selectedNode = null;
            if (this.$refs.bellList) {
                this.$refs.bellList.resetSelectedBell();
            }
        },
        handleShowCsvDialog() {
            if (this.appData.csvProcessing) {
                commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n,"error_import_processing"));
                return;
            }
            this.showImportError = false;
            this.showImportCsv = true
        },
        handleOnSelectNode(node) {
            this.selectedNode = node;
        },
        handleCloseCSVProgress() {
            this.showImportCsvProcess = false;
            if (this.csvErrorCount > 0) {
                this.showImportError = true;
                this.showImportCsv = true
            }
        },
        handleCancelImport() {
            this.canceling = true;
            this.csvProcessStatusDescription = this.getImportStatusDescription();
            let self = this;
            server.post("/changecsvimportprocess",{ type: "ABORT", importType: self.csvType })
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","handleCancelImport").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch(err => {
                    commonUtil.putExceptionErrorMessage(self, "handleCancelImport", err);
                });
        },
        enableCreateCommand() {
            this.disableCreateBell = false;
        },
        disableCreateCommand() {
            this.disableCreateBell = true;
        },
        handleRefreshBellList(resetSelect) {
            this.$refs.bellList.reload();
            if (resetSelect) {
                this.resetSelectedNode();
            }
        },
        getExpireDateTime() {
            if (this.appData.basicContract.purchasePeriodType == constants.PURCHASE_PERIOD_TRIAL) {
                return new Date(this.appData.basicContract.startDatetime).toLocaleString();
            } else {
                return new Date(this.appData.basicContract.nextFlushDatetime).toLocaleString();
            }
        },
        isExpireTrialContract() {
            if ((this.appData.basicContract != null) && (this.appData.basicContract.state == constants.CONTRACT_TRIAL_END)) {
                return true;
            } else {
                return false;
            }
        },
        isExpirePurchasedContract() {
            if ((this.appData.basicContract != null) && (this.appData.basicContract.state == constants.CONTRACT_TERMINATE)) {
                return true;
            } else {
                return false;
            }
        },
        isBillingPaper() {
            if ((this.appData.basicContract != null) && (this.appData.basicContract.billingType == constants.BILLING_PAPER)) {
                return true;
            } else {
                return false;
            }
        },
        getLocalOffsetMinutes() {
            // Use this api because this is older than ```Intl.DateTimeFormat().resolvedOptions().timeZone;```
            return -(new Date().getTimezoneOffset());
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
tr.itemheader {
}

.inner-panel {
    position:relative;
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    overflow: auto;
    background-color: #ffffff;
}

.scrollable {
    overflow: auto;
    position: absolute;
    top: 0;
    right:0;
    bottom: 0;
    left: 0;
}

.command-area {
    background-color: #ecf1fa;
    width: 100%;
    display: block;
    text-align: left;
    padding-left: 20px;
    height: 56px;
    vertical-align: bottom;
}

.command-area img {
  display: inline;
  vertical-align: middle;
  height: 25px;
  padding-left: 16px;
  padding-right: 4px;
}
.command-area-left {
    padding-top: 10px;
    padding-bottom: 10px;
    vertical-align: middle;
    float: left;
}
.command-area-right {
    padding-right: 24px;
    padding-top: 15px;
    text-align : right;
    vertical-align: middle;
}
.normal-command {
    color: #5171cb;

}
.normal-command:hover {
    opacity: 0.7;
}
.csv-progress-title {
    padding: 10px 0 20px 0;
    text-align: center;
}
.bellList {
    overflow: hidden;
    position: absolute;
    top: 0;
    right:0;
    bottom: 0;
    left: 0;
}
</style>
